export type EventVideoEquipmentCategory = {
  category: string;
  items: string[];
};

/** イベント運営企画・映像オペレーション：主な保有機材（トップ／詳細ページ共通） */
export const EVENT_VIDEO_MAIN_EQUIPMENT: EventVideoEquipmentCategory[] = [
  { category: 'ビデオミキサー（スイッチャー）', items: ['ROLAND V-80HD'] },
  {
    category: 'カメラ',
    items: ['Panasonic LUMIX S5M2X', 'Panasonic LUMIX GH5M2', 'Canon EOS 80D', 'GoPro9'],
  },
  {
    category: 'レンズ（Lマウント）',
    items: [
      'SIGMA Art 24-70mm F2.8 DG DN',
      'SIGMA Sports 150-600mm F5-6.3 DG DN OS',
      'Panasonic LUMIX S 20-60mm F3.5-5.6',
      'Panasonic LUMIX S 50mm F1.8',
    ],
  },
  {
    category: 'レンズ（MFTマウント）',
    items: [
      'LEICA DG VARIO-ELMARIT 8-18mm/F2.8-4.0 ASPH./POWER O.I.S.',
      'LEICA DG VARIO-ELMARIT 50-200mm/F2.8-4.0 ASPH./POWER O.I.S.',
      'Panasonic LUMIX GX VARIO 12mm-35mm F2.8 POWER O.I.S',
      'Panasonic LUMIX GX VARIO 35mm-100mm F2.8 POWER O.I.S',
    ],
  },
  { category: 'オーディオミキサー', items: ['behringer Flow8'] },
];
